import { makeStyles } from '@material-ui/core';
import { CartPiece } from 'components/WidgetInflationCart/WidgetInflationCart';
import React from 'react';

interface EducationCardProps {
    card: CartPiece;
}

const useStyles = makeStyles((theme) => ({
    educationCard: {
        backgroundColor: '#71C9CE',
        width: '298px',
        height: '363px',
        flexShrink: 0,
        borderRadius: '10px',
        padding: '20px',
        [theme.breakpoints.down('sm')]: {
            height: '300px',
        },
    },
    svg: {
        width: '66px',
        height: '74px',
        flexShrink: 0,
        fill: theme.colors.white,
    },
    h3: {
        color: theme.colors.white,
        textAlign: 'center',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 'normal',
    },
    li: {
        color: theme.colors.white,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        // lineHeight: 'normal',
        lineHeight: '30px' /* 178.571% */,
    },
    svgIcon: {
        textAlign: 'center',
    },
    hr: {
        border: '1px solid white',
    },
    desc: {
        display: 'flex',
        lineHeight: '17px',
    },
}));

const Education = ({ card }: EducationCardProps) => {
    const classes = useStyles();
    return (
        <div className={classes.educationCard}>
            <div className={classes.svgIcon}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={classes.svg}
                    width="66"
                    height="74"
                    viewBox="0 0 66 74"
                    fill="none"
                    data-card={card.card}
                >
                    <path
                        d="M52.9487 64.1948C52.9487 64.6265 52.6018 64.9835 52.164 64.9835H12.5722C12.1427 64.9835 11.7875 64.6348 11.7875 64.1948C11.7875 63.7547 12.1344 63.406 12.5722 63.406H52.164C52.5935 63.406 52.9487 63.763 52.9487 64.1948ZM19.23 48.0714H53.9317C54.3612 48.0714 54.7164 47.7227 54.7164 47.2826C54.7164 46.8426 54.3695 46.4939 53.9317 46.4939H19.23C18.8005 46.4939 18.4453 46.8426 18.4453 47.2826C18.4453 47.7227 18.7922 48.0714 19.23 48.0714ZM66 16.9288C66 18.0579 65.3722 19.0376 64.3149 19.544L54.4108 24.2931V36.4728C54.4108 37.3196 54.1877 38.0171 53.8408 38.6065C58.574 38.648 62.4068 42.5253 62.4068 47.2909C62.4068 50.23 60.9447 52.8287 58.7144 54.4062H59.5404C60.7464 54.4062 61.7211 55.3941 61.7211 56.598V58.0094C61.7211 59.2216 60.7382 60.2013 59.5404 60.2013H58.9539C58.6731 60.4171 58.0536 61.7787 58.0536 64.2031C58.0536 66.6274 58.6648 67.989 58.9539 68.2049H59.5404C60.7464 68.2049 61.7211 69.1929 61.7211 70.3967V71.8082C61.7211 73.0203 60.7382 74 59.5404 74H12.7539C7.37647 74 3.00676 69.608 3.00676 64.2031C3.00676 59.4541 6.38523 55.4855 10.8541 54.5971C10.788 54.3978 10.7384 54.182 10.7384 53.9578V52.7208C10.7384 51.6082 11.6388 50.7032 12.7457 50.7032H13.2165C13.4561 50.4625 13.9434 49.2752 13.9434 47.2909C13.9434 45.3066 13.4561 44.1194 13.2165 43.8786H12.7457C11.6388 43.8786 10.7384 42.9736 10.7384 41.8611V40.624C10.7384 39.7025 11.3579 38.9303 12.2005 38.6896C11.8205 38.0835 11.581 37.3612 11.581 36.4728V24.2931L7.02954 22.1095V40.5576C8.01252 40.8897 8.7229 41.8113 8.7229 42.9072C8.7229 43.3306 8.60726 43.7209 8.42553 44.0696L9.44981 48.611C9.49937 48.8435 9.44981 49.0926 9.30113 49.2752C9.15244 49.4662 8.92941 49.5741 8.68986 49.5741H3.81627C3.57672 49.5741 3.35369 49.4662 3.20501 49.2752C3.05632 49.0843 2.9985 48.8435 3.05632 48.611L4.0806 44.0696C3.89887 43.7209 3.78323 43.3306 3.78323 42.9072C3.78323 41.8113 4.49362 40.8897 5.4766 40.5576V21.3623L1.68511 19.544C0.636045 19.0376 0 18.0579 0 16.9288C0 15.7996 0.627785 14.8199 1.68511 14.3135L30.1089 0.672501C31.9757 -0.224167 34.0325 -0.224167 35.8911 0.672501L64.3149 14.3218C65.3722 14.8199 66 15.7996 66 16.9288ZM7.71514 47.9966L7.09562 45.2402C6.83129 45.3315 6.5587 45.398 6.26133 45.398C5.96395 45.398 5.69136 45.3398 5.42703 45.2402L4.80751 47.9966H7.71514ZM7.1617 42.9072C7.1617 42.4008 6.75695 41.9939 6.25307 41.9939C5.74919 41.9939 5.34443 42.4008 5.34443 42.9072C5.34443 43.4137 5.74919 43.8205 6.25307 43.8205C6.75695 43.8205 7.1617 43.4137 7.1617 42.9072ZM19.61 42.3011C18.4618 42.0105 17.3136 41.6951 16.1737 41.3214C15.6533 41.1471 14.6373 40.815 13.6874 40.1757H12.7539C12.5061 40.1757 12.3079 40.375 12.3079 40.624V41.8611C12.3079 42.1102 12.5061 42.3094 12.7539 42.3094H19.61V42.3011ZM15.5294 47.2909C15.5294 48.528 15.3559 49.7651 15.0008 50.7032H53.4113C55.4763 50.7032 57.1615 49.1756 57.1615 47.2909C57.1615 45.4146 55.4763 43.8786 53.4113 43.8786H15.0008C15.3559 44.8085 15.5294 46.0539 15.5294 47.2909ZM53.7665 55.9753H12.7539C8.2438 55.9753 4.56796 59.6616 4.56796 64.1948C4.56796 68.7279 8.23554 72.4142 12.7539 72.4142H59.5404C59.8791 72.4142 60.1599 72.132 60.1599 71.7915V70.3801C60.1599 70.0397 59.8791 69.7574 59.5404 69.7574H13.167C9.87935 69.7574 7.21126 67.2584 7.21126 64.1865C7.21126 61.1146 9.87935 58.6155 13.167 58.6155H59.5404C59.8791 58.6155 60.1599 58.3332 60.1599 57.9928V56.5814C60.1599 56.241 59.8791 55.9587 59.5404 55.9587H53.7665V55.9753ZM56.4924 64.1948C56.4924 62.7335 56.6989 61.2557 57.1449 60.193H13.167C10.7467 60.193 8.78073 61.9863 8.78073 64.1948C8.78073 66.4032 10.7467 68.1966 13.167 68.1966H57.1449C56.6989 67.1339 56.4924 65.6643 56.4924 64.1948ZM53.7665 40.1757H52.2961C51.3627 40.8067 50.3467 41.1471 49.8263 41.3214C48.6946 41.6951 47.563 42.0189 46.423 42.3011H53.4113C56.3437 42.3011 58.7309 44.5345 58.7309 47.2826C58.7309 50.0307 56.3437 52.2641 53.4113 52.2641H12.7539C12.5061 52.2641 12.3079 52.4634 12.3079 52.7124V53.9495C12.3079 54.1986 12.5061 54.3978 12.7539 54.3978H53.7665C57.6653 54.3978 60.8456 51.2097 60.8456 47.2826C60.8456 43.3639 57.6736 40.1757 53.7665 40.1757ZM52.8496 25.0486L35.8994 33.185C34.966 33.6333 33.983 33.8575 33.0083 33.8575C32.0253 33.8575 31.0506 33.6333 30.1171 33.185L13.167 25.0486V36.4728C13.167 37.9755 14.2821 39.0466 16.6693 39.827C21.9146 41.5456 26.9865 42.3094 33.0909 42.3094C39.1374 42.3094 44.1514 41.5456 49.3472 39.827C51.7427 39.0383 52.8578 37.9755 52.8578 36.4728V25.0486H52.8496ZM64.4388 16.9288C64.4388 16.414 64.1497 15.974 63.6458 15.7332L35.2138 2.09222C34.4951 1.74352 33.7434 1.56917 33 1.56917C32.2566 1.56917 31.5049 1.74352 30.778 2.09222L2.35419 15.7332C1.85031 15.974 1.5612 16.4057 1.5612 16.9288C1.5612 17.4518 1.85031 17.8835 2.35419 18.1243L6.37697 20.0588L32.8844 16.1566C33.3139 16.0902 33.7104 16.3891 33.7765 16.8208C33.8426 17.2526 33.5452 17.6511 33.1156 17.7175L8.91289 21.2793L30.7862 31.7653C32.2401 32.4627 33.7682 32.4627 35.222 31.7653L63.6458 18.116C64.1497 17.8752 64.4388 17.4435 64.4388 16.9288Z"
                        fill="white"
                    />
                </svg>
            </div>
            <hr className={classes.hr} />
            <h3 className={classes.h3}>{card.header}</h3>
            <ul>
                {card.list.map((item) => (
                    <li
                        className={classes.li}
                        key={`${card.card}-${Math.random()}`}
                    >
                        <span className={classes.desc}>{item.desc}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Education;
